// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2Hr7I","label":"Radio_label__1yzEd","checkMark":"Radio_checkMark__1Hvlg","disabled":"Radio_disabled__2mYvh"};